const FRONTMATTER = /^---\r?\n[\s\S]*?\r?\n---\r?\n?/;
const FRONTMATTER_BLOCK = /^---\r?\n([\s\S]*?)\r?\n---/;

export function stripFrontmatter(md: string): string {
  return md.replace(FRONTMATTER, '');
}

export function extractSourcePath(md: string): string | undefined {
  if (!md) return undefined;
  const block = md.match(FRONTMATTER_BLOCK);
  if (!block) return undefined;
  const line = block[1].match(/^source_path:\s*(.+?)\s*$/m);
  if (!line) return undefined;
  let val = line[1].trim();
  if (
    (val.startsWith('"') && val.endsWith('"')) ||
    (val.startsWith("'") && val.endsWith("'"))
  ) {
    val = val.slice(1, -1);
  }
  return val || undefined;
}

export function markdownToPlainText(md: string): string {
  let text = stripFrontmatter(md);

  text = text.replace(/```[\w-]*\r?\n([\s\S]*?)```/g, '$1');
  text = text.replace(/`([^`]+)`/g, '$1');

  text = text.replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1');
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

  text = text.replace(/(\*\*|__)(.+?)\1/g, '$2');
  text = text.replace(/(\*|_)(.+?)\1/g, '$2');
  text = text.replace(/~~(.+?)~~/g, '$1');

  text = text.replace(/^\s{0,3}#{1,6}\s+/gm, '');
  text = text.replace(/^\s*>\s?/gm, '');
  text = text.replace(/^\s*[-*+]\s+/gm, '');
  text = text.replace(/^\s*\d+\.\s+/gm, '');

  text = text.replace(/\n{3,}/g, '\n\n');
  return text.trim();
}

export function sanitizeFilename(slug: string): string {
  const cleaned = slug.replace(/[^a-zA-Z0-9._-]+/g, '-').replace(/^-+|-+$/g, '');
  return cleaned.length > 0 ? cleaned : 'result';
}
